<template>
    <div class="row">
        <div class="col-6 form-group">
            <label for="firstName">First name</label>
            <input
                id="firstName"
                v-model="student.firstName"
                type="text"
                class="form-control"
                dir="auto"
                :class="{
                    'is-invalid': hasError('firstName')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('firstName') }}
            </div>
        </div>

        <div class="col-6 form-group">
            <label for="lastName">Last name</label>
            <input
                id="lastName"
                v-model="student.lastName"
                type="text"
                class="form-control"
                dir="auto"
                :class="{
                    'is-invalid': hasError('lastName')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('lastName') }}
            </div>
        </div>

        <div class="col-6 form-group">
            <label for="email">Email</label>
            <input
                id="email"
                v-model="student.email"
                type="text"
                class="form-control"
                dir="auto"
                :class="{
                    'is-invalid': hasError('email')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('email') }}
            </div>
        </div>

        <div class="col-6 form-group">
            <label for="phone">Phone</label>
            <input
                id="phone"
                v-model="student.phone"
                type="text"
                class="form-control"
                dir="auto"
                :class="{
                    'is-invalid': hasError('phone')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('phone') }}
            </div>
        </div>

        <div class="col-6 form-group">
            <label for="tz">Tz</label>
            <input
                id="tz"
                v-model="student.tz"
                type="text"
                class="form-control"
                dir="auto"
                :class="{
                    'is-invalid': hasError('tz')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('tz') }}
            </div>
        </div>

        <div class="col-6 form-group">
            <label for="sex">Sex</label>
            <v-select
                id="sex"
                v-model="student.sex"
                :options="['male', 'female']"
                :clearable="false"
                dir="auto"
                :class="{
                    'is-invalid': hasError('sex')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('sex') }}
            </div>
        </div>

        <div class="col-6 form-group">
            <label for="stars">Stars</label>
            <input
                id="stars"
                v-model="student.stars"
                type="number"
                class="form-control"
                :class="{
                    'is-invalid': hasError('stars')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('stars') }}
            </div>
        </div>

        <div class="col-6 form-group">
            <label for="membershipStatus">Membership status</label>
            <input
                id="membershipStatus"
                v-model="student.membershipStatus"
                type="text"
                dir="auto"
                class="form-control"
                :class="{
                    'is-invalid': hasError('membershipStatus')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('membershipStatus') }}
            </div>
        </div>

        <div class="col-6 form-group">
            <label for="yearOfStudy">Year of study</label>
            <input
                id="yearOfStudy"
                v-model="student.yearOfStudy"
                type="number"
                step="1"
                dir="auto"
                class="form-control"
                :class="{
                    'is-invalid': hasError('yearOfStudy')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('yearOfStudy') }}
            </div>
        </div>

        <div class="col-6 form-group">
            <label for="hugs">Hugs</label>
            <v-select
                id="hugs"
                v-model="student.hugs"
                label="number"
                :options="hugs"
                multiple
                :clearable="false"
                :class="{
                    'is-invalid': hasError('hugs')
                }"
                @search="onHugsSearch"
            />

            <div class="invalid-feedback">
                {{ getError('hugs') }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            student: {},
            hugs: [],
            timer: 0
        };
    },

    watch: {
        student() {
            this.$emit('input', this.student);
        }
    },

    created() {
        this.student = { ...this.value };
    },

    methods: {
        ...mapActions({
            getHugs: 'hugs/index'
        }),

        async fetchHugs(search) {
            try {
                const { rows: hugs } = await this.getHugs({
                    search
                });

                this.hugs = hugs;
            } catch (err) {
                console.error(err);

                this.$toasted.global.error();
            }
        },

        async onHugsSearch(search, loading) {
            if (search.length) {
                loading(true);

                if (this.timer) {
                    clearTimeout(this.timer);

                    this.timer = null;
                }

                this.timer = setTimeout(async () => {
                    await this.fetchHugs(search);

                    loading(false);
                }, 500);
            }
        },

        hasError(key) {
            return (
                this.validation.student[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.student,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
